import { connect } from 'react-redux'

const mapStateToProps = ({ stateInfo }) => ({
  stateInfo,
})

export default connect(mapStateToProps)



// WEBPACK FOOTER //
// ./src/components/PositionsScene/PositionsList/StateInfoItem/stateInfoItemContainer.js